import { main_phaser } from "./MadnesApp";
import {he_scale, madnes_objects, wi_scale} from "./madnes_variables";

export function madnes_add_graphics(key, x, y)
{
    if(typeof madnes_objects[key] !== 'undefined') {
        console.warn('Graphics with key `' + key + '`  already exists!');
    }

    madnes_objects[key] = main_phaser.add.graphics(x * wi_scale, y * he_scale);
}

export function madnes_add_mask(objKey, graphKey) {
    madnes_objects[objKey].mask = madnes_objects[graphKey];
}

/**
 * @param {string} key
 * @param {number=} lineWidth
 * @param {number=} color
 * @param {number=} alpha
 */
export function madnes_graphics_set_line_style(key, lineWidth, color, alpha)
{
    madnes_objects[key].lineStyle(lineWidth, color, alpha);
}

export function madnes_graphics_begin_fill(key, color)
{
    madnes_objects[key].beginFill(color);
}

export function madnes_graphics_end_fill(key)
{
    madnes_objects[key].endFill();
}

export function madnes_graphics_draw_rectangle(key, x, y, width, height)
{
    madnes_objects[key].drawRect(x * wi_scale, y * he_scale, width * wi_scale, height * he_scale);
}

export function madnes_graphics_draw_circle(key, x, y, diameter)
{
    madnes_objects[key].drawCircle(x * wi_scale, y * he_scale, diameter / multi);
}

export function madnes_graphics_clear(key)
{
    madnes_objects[key].clear();
}

export function madnes_graphics_move_to(key, x, y)
{
    madnes_objects[key].moveTo(x * wi_scale, y * he_scale);
}

export function madnes_graphics_line_to(key, x, y)
{
    madnes_objects[key].lineTo(x * wi_scale, y * he_scale);
}

